module.exports = __webpack_public_path__ + "img/Biene-auf-Blume-v2-200.52a4d5b7.png";